var __TEMP__ = require('./_createCompounder.js');var createCompounder = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./upperFirst.js');var upperFirst = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = startCase;
